export interface SignUpFormValues {
  email: string;
  acceptTerms: boolean;
  verifyCode: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  username: string;
  companyName: string;
  subscriptionDuration: boolean;
  subscriptionPlan: boolean;
  otpSent?: boolean;
}

export interface TempTokens {
  accessToken: string;
  refreshToken: string;
}

export const SignUpFormDefaultValues = {
  email: '',
  acceptTerms: false,
  verifyCode: '',
  password: '',
  confirmPassword: '',
  firstName: '',
  lastName: '',
  username: '',
  companyName: '',
  subscriptionDuration: false,
  subscriptionPlan: false,
  otpSent: false,
};

export const TempTokensDefaultValues = {
  accessToken: '',
  refreshToken: '',
};

export const BusinessSignUpFormDefaultValues = {
  firstName: '',
  lastName: '',
  companyName: '',
  email: '',
  phone: '',
  password: '',
  confirmPassword: '',
  acceptTerms: false,
};
